/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_bulkUpdateSupportRequestsRequest } from '../models/api_bulkUpdateSupportRequestsRequest';
import type { api_supportRequestUpdateRequest } from '../models/api_supportRequestUpdateRequest';
import type { api_validateSupportRequestResponse } from '../models/api_validateSupportRequestResponse';
import type { db_GetSupportRequestCountsRow } from '../models/db_GetSupportRequestCountsRow';
import type { db_GetSupportRequestRow } from '../models/db_GetSupportRequestRow';
import type { db_ListSupportRequestCommentsHistoryRow } from '../models/db_ListSupportRequestCommentsHistoryRow';
import type { db_ListSupportRequestCommentsRow } from '../models/db_ListSupportRequestCommentsRow';
import type { db_ListSupportRequestsRow } from '../models/db_ListSupportRequestsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportRequests {
    /**
     * Get a list of support requests (admin)
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListSupportRequestsRow OK
     * @throws ApiError
     */
    public static listSupportRequests(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListSupportRequestsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary support request (self, token)
     * @param file File to be uploaded
     * @param comment
     * @param supportRequestCategoryId
     * @returns void
     * @throws ApiError
     */
    public static createSupportRequest(
        file?: Blob,
        comment?: string,
        supportRequestCategoryId?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/support-requests',
            formData: {
                'file': file,
                'comment': comment,
                'support_request_category_id': supportRequestCategoryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk update support requests
     * @param body Bulk update support request details
     * @returns void
     * @throws ApiError
     */
    public static bulkUpdateSupportRequests(
        body: api_bulkUpdateSupportRequestsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/support-requests/bulk-update',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get support request stats (admin)
     * @param isAssignedToMe Is assigned to current user
     * @returns db_GetSupportRequestCountsRow OK
     * @throws ApiError
     */
    public static getSupportRequestCounts(
        isAssignedToMe?: boolean,
    ): CancelablePromise<db_GetSupportRequestCountsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests/counts',
            query: {
                'is_assigned_to_me': isAssignedToMe,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get support request (admin)
     * @param id Support request ID
     * @returns db_GetSupportRequestRow OK
     * @throws ApiError
     */
    public static getSupportRequest(
        id: number,
    ): CancelablePromise<db_GetSupportRequestRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update support request (admin)
     * @param id Support request ID
     * @param supportRequest Support request data
     * @returns void
     * @throws ApiError
     */
    public static updateSupportRequest(
        id: number,
        supportRequest: api_supportRequestUpdateRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/support-requests/{id}',
            path: {
                'id': id,
            },
            body: supportRequest,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List support request comments (admin)
     * @param id Support request ID
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListSupportRequestCommentsRow OK
     * @throws ApiError
     */
    public static listSupportRequestComments(
        id: number,
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListSupportRequestCommentsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests/{id}/comments',
            path: {
                'id': id,
            },
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary support request comment (self, token)
     * @param id Support request ID
     * @param file File to be uploaded
     * @param comment
     * @param countryCallingCode
     * @param dateOfBirth
     * @param phone
     * @param recoveryEmail
     * @param token
     * @returns void
     * @throws ApiError
     */
    public static createSupportRequestComment(
        id: number,
        file?: Blob,
        comment?: string,
        countryCallingCode?: number,
        dateOfBirth?: string,
        phone?: string,
        recoveryEmail?: string,
        token?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/support-requests/{id}/comments',
            path: {
                'id': id,
            },
            formData: {
                'file': file,
                'comment': comment,
                'country_calling_code': countryCallingCode,
                'date_of_birth': dateOfBirth,
                'phone': phone,
                'recovery_email': recoveryEmail,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get support request by token (self)
     * @param id Support request ID
     * @param token Token
     * @param dateOfBirth Date of birth
     * @param countryCallingCode Country calling code
     * @param phone Phone
     * @param recoveryEmail Recovery email
     * @returns db_ListSupportRequestCommentsHistoryRow OK
     * @throws ApiError
     */
    public static getSupportRequestByToken(
        id: number,
        token: string,
        dateOfBirth?: string,
        countryCallingCode?: number,
        phone?: string,
        recoveryEmail?: string,
    ): CancelablePromise<Array<db_ListSupportRequestCommentsHistoryRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests/{id}/token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            query: {
                'date_of_birth': dateOfBirth,
                'country_calling_code': countryCallingCode,
                'phone': phone,
                'recovery_email': recoveryEmail,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate support request token (self)
     * @param id Support request ID
     * @param token Token
     * @returns api_validateSupportRequestResponse OK
     * @throws ApiError
     */
    public static validateSupportRequestToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateSupportRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-requests/{id}/validate-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
